import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default function () {
  useGSAP(() => {
    let tl = gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: 'power1.out',
      },
      scrollTrigger: {
        trigger: "#icon-ring-bell",
        start: "top bottom-=100px",
        end: "bottom+=50px bottom",
        markers: false,
        toggleActions: "play none play reset"
      }
    });

    tl.to('.bell', { 
        rotate: -5,
        ease: 'power1.out',
        transformOrigin: 'center top' 
      })
      .to('.bell', { 
        rotate: 5,
      })
      .to('.bell', { 
        rotate: -5,
      })
      .to('.bell', { 
        rotate: 5,
      })
      .to('.bell', {
        rotate: 0,
      })
    });

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.4 118.24" id="icon-ring-bell">
			<g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
				<g className="bell">
					<path d="M60.2 11.11c-3.12 0-5.63 2.51-5.63 5.63v6.16c-14.93 2.66-26.28 15.69-26.28 31.39V86.2l-7.51 16.9h78.85l-7.51-16.9V54.29c0-15.7-11.35-28.72-26.28-31.39v-6.16c0-3.12-2.51-5.63-5.63-5.63h0Z" />
					<path d="M73.34 103.1c0 7.26-5.88 13.14-13.14 13.14s-13.14-5.88-13.14-13.14" />
				</g>
				<g>
					<path d="M103.37 41.15c0-10.46-6.11-19.49-14.95-23.72" />
					<path d="M117.99 46.97c.27-1.9.41-3.84.41-5.82 0-18.2-11.77-33.64-28.11-39.15" />
				</g>
				<g>
					<path d="M17.02 41.15c0-10.46 6.11-19.49 14.95-23.72" />
					<path d="M2.41 46.97c-.27-1.9-.41-3.84-.41-5.82C2 22.95 13.77 7.5 30.11 2" />
				</g>
			</g>
		</svg>
 );
}